import { Event } from './event'

const buildFullEventType = (event: Event) => `${event.context}.${event.entity}.${event.type}`

export { buildFullEventType }
